/**
 *
 * ErrorBoundary
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  ErrorBoundary as ErrorBoundaryComponent,
  Text,
  Space,
} from '@cashfree-intl/coherent';

// utils
import { sentryCaptureException } from 'utils/common';

const ERROR_BOUNDARY_FALLBACK = (
  <Space
    alignItems="center"
    justifyContent="space-around"
    className="error-boundary-container"
  >
    <div className="content text-center mx-1">
      <h1 className="error-heading">OOPS !</h1>
      <div className="description-wrapper text-center">
        <Text variant="h20" color="bodyLight">
          Something went wrong. We are currently trying to fix the problem.
        </Text>
        <Text variant="h16" strong color="bodyLight">
          Please empty cache and hard refresh to try again or{' '}
          <a href={`${process.env.PUBLIC_PATH}landing`}>Go back to homepage</a>
        </Text>
      </div>
    </div>
  </Space>
);

const ErrorBoundary = ({ fallback = ERROR_BOUNDARY_FALLBACK, children }) => (
  <ErrorBoundaryComponent fallback={fallback} onError={sentryCaptureException}>
    {children}
  </ErrorBoundaryComponent>
);

ErrorBoundary.propTypes = {
  children: PropTypes.element,
  fallback: PropTypes.element,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  null,
  mapDispatchToProps,
);

export default compose(withConnect)(ErrorBoundary);
